module.exports = __webpack_public_path__ + "static/delightful_transaction_list-e669559826abff1fdb2b299e98747db4.webp";